import React, { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { Button, NubeskIcons } from "components/atoms";
import { FlexComponent, TaskSearchPanel } from "components/templates";
import { useTasks } from "_hooks";
import { openModal } from "_redux/ui/ui.actions";
import { selectTaskAll } from "_redux/task/task.selector";

const TaskToolbar = () => {
  const dispatch = useDispatch();
  const { fetch } = useTasks();
  let { t } = useTranslation();

  const { data: tasks } = useSelector(selectTaskAll);

  const handleSearch = useCallback((searchValue, useAction) => {
    if (!searchValue) {
      fetch();
      return;
    } else {
      let values = searchValue;
      let output = {};

      if (values.length) {
        values = values.replace(/[^a-zA-Z0-9]/g, "");
        let regex = values.split('').join('[^a-zA-Z0-9]*');
        
        let conditionSearch = {
          "$regex": regex,
          "$options": 'i'
        };
        let arraySearch = [{name: conditionSearch}];

        output = {
          ...output,
          $or: arraySearch
        };
      }
      
      fetch({ w: output });
    }
  }, [fetch]);

  return (
    <>
      <FlexComponent>
        <Button
          leftIcon={<NubeskIcons icon="plus"/>}
          content={t("tasks:actions.newTask")}
          type={"primary"}
          onClick={() => dispatch(openModal({
            header: {
              icon: { type: "plus", size: 18 },
              text: t("modals:addToTask.title")
            },
            modalProps: {
              auto: false,
              type: "new"
            },
            typeModal: "addToTask"
          }))}
        />
      </FlexComponent>
      <TaskSearchPanel
        counterName={t("tasks:actions.counterName")}
        disabled={false}
        qty={tasks?.length || 0}
        total={tasks?.length || 0}
        placeholder={t("tasks:actions.searchBy")}
        onSearch={handleSearch}
        useAction={false}
      />
    </>
  );
};

export default TaskToolbar;
